(function ($) {
    $(function () {
        $(document).on('input', '.js-has-error input,.js-has-error textarea', function (e) {
            $(this).parents('.js-has-error').removeClass('has--error js-has-error');
        });


        $(document).on('change', '.js-has-error .form-check-input,.js-has-error select', function (e) {
            $(this).parents('.js-has-error').removeClass('has--error js-has-error');
        });
    });
})(jQuery);